'use es6';

import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import AdWordsGenericAdReportingRecord from 'AdsUI/records/reporting/AdWordsGenericAdReportingRecord';
import AdWordsImageAdReportingRecord from 'AdsUI/records/reporting/AdWordsImageAdReportingRecord';
import AdWordsLegacyAppAdReportingRecord from 'AdsUI/records/reporting/AdWordsLegacyAppAdReportingRecord';
import { AdWordsAdTypes, AdWordsCharacterLimits } from 'AdsUI/lib/Constants';
import AdWordsTextAdReportingRecord from 'AdsUI/records/reporting/AdWordsTextAdReportingRecord';
const APP_STORE_KEY = {
  GOOGLE_PLAY: 'downloadOnGooglePlay'
};

const getShortDisplayUrl = displayUrl => displayUrl ? displayUrl.substring(0, AdWordsCharacterLimits.displayUrlVisible) : '';

const TextAdTitle = ({
  entity
}) => /*#__PURE__*/_jsx("a", {
  className: "external-link post-icon",
  href: entity.finalUrl,
  target: "_blank",
  rel: "noopener noreferrer",
  children: entity.name
});

const AD_TITLE = {
  [AdWordsAdTypes.TEXT_AD]: TextAdTitle,
  [AdWordsAdTypes.LEGACY_APP_INSTALL_AD]: TextAdTitle,
  [AdWordsAdTypes.RESPONSIVE_SEARCH_AD]: TextAdTitle,
  [AdWordsAdTypes.SMART_CAMPAIGN_AD]: TextAdTitle
};

const AdUrl = ({
  entity,
  entity: {
    type,
    appStore
  }
}) => {
  if (type === AdWordsAdTypes.LEGACY_APP_INSTALL_AD) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: `adWordsCampaignCreation.createAd.appStores.${APP_STORE_KEY[appStore] || 'downloadOnITunes'}`
    });
  }

  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx("div", {
      className: "display-inline-block adwords-ad-badge",
      children: "Ad"
    }), getShortDisplayUrl(entity.getDisplayUrl())]
  });
};

const AdWordsGenericAdPreview = ({
  entity
}) => {
  const AdTitle = AD_TITLE[entity.type];
  return /*#__PURE__*/_jsxs("div", {
    className: "adwords-ad-preview",
    children: [AdTitle && /*#__PURE__*/_jsx(AdTitle, {
      entity: entity
    }), /*#__PURE__*/_jsx("div", {
      className: "ad-url",
      children: /*#__PURE__*/_jsx(AdUrl, {
        entity: entity
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "ad-copy",
      children: [entity.description, !!entity.description2 && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("br", {}), entity.description2]
      })]
    })]
  });
};

AdWordsGenericAdPreview.propTypes = {
  entity: PropTypes.oneOfType([PropTypes.instanceOf(AdWordsGenericAdReportingRecord), PropTypes.instanceOf(AdWordsImageAdReportingRecord), PropTypes.instanceOf(AdWordsLegacyAppAdReportingRecord), PropTypes.instanceOf(AdWordsTextAdReportingRecord)])
};
export default AdWordsGenericAdPreview;